/**
 * Проверяет является ли значение правдивым (truthy)
 * @example
 * type TElement = { a: number };
 *
 * const all: Array<TElement | undefined | null> = [
 *   undefined,
 *   { a: 1 },
 *   { a: 2 },
 *   null,
 * ];
 * const truthy = all.filter(isTruthy); // returns TElement[]
 */
const isTruthy = Boolean as unknown as <T>(x: T) => x is T extends false | '' | 0 ? never : NonNullable<T>;

export default isTruthy;
